import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';
import _ from 'lodash';

const validateCriteriaWeights = (criteria) => {
  const errors = [];
  const groupedCriteriaByCategory = _.groupBy(criteria, 'categoryId');
  _.forEach(groupedCriteriaByCategory, group => {
    const reducedWeighOld = _.reduce(group, (sum, current) => { return sum + current.weightOld}, 0);
    const reducedWeightNewComing = _.reduce(group, (sum, current) => { return sum + current.weightNewComing}, 0);
    const reducedWeightNew = _.reduce(group, (sum, current) => { return sum + current.weightNew}, 0);
    let category;
    try {
      category = group[0].category
    } catch (e) {
      category = {};
    }
    if(reducedWeighOld !== 100 && reducedWeighOld) {
      category && errors.push(
        `Η εξάμηνη βαρύτητα δεν αθροίζεται στο 100 για την κατηγορία: ${category.name} (Σύνολο: ${reducedWeighOld})`
      )
    }
    if(reducedWeightNewComing !== 100 && reducedWeightNewComing) {
      category && errors.push(
        `Η βαρύτητα των υφιστάμενων καταστημάτων δεν αθροίζεται στο 100 για την κατηγορία: ${category.name} (Σύνολο: ${reducedWeightNewComing})`
      )
    }
    if(reducedWeightNew !== 100 && reducedWeightNew) {
      category && errors.push(
        `Η βαρύτητα των νέων καταστημάτων δεν αθροίζεται στο 100 για την κατηγορία: ${category.name} (Σύνολο: ${reducedWeightNew})`
      )
    }
  });
  return errors;
};

const INITIAL_STATE = fromJS({
  criteria: fromJS([]),
  fetching: false,
  errors: fromJS([])
});

function getCriteria(state, action){
  return state
    .set('fetching', true);
}

function getCriteriaSuccess(state, action) {
  //validate criteria of categories
  const errors =  validateCriteriaWeights(action.payload.body);
  return state
    .set('criteria', fromJS(action.payload.body))
    .set('fetching', false)
    .set('errors', fromJS(errors))
}

function getCriteriaFailed(state, action) {
  return state
    .set('fetching', false);
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function changeCriteriaState(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value));
}

function getCriteriaWithFilters(state, action) {
  return state
    .set('fetching', true);
}

function getCriteriaWithFiltersSuccess(state, action) {
  return state
    .set('criteria', fromJS(action.payload.body))
    .set('fetching', false)
}

function getCriteriaWithFiltersFailed(state, action) {
  return state
    .set('fetching', false);
}

export const criteria = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_CRITERIA]: getCriteria,
  [ActionTypes.GET_CRITERIA_SUCCESS]: getCriteriaSuccess,
  [ActionTypes.GET_CRITERIA_FAILED]: getCriteriaFailed,
  [ActionTypes.LOG_OUT]: resetState,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.CHANGE_CRITERIA_STATE]: changeCriteriaState,
  [ActionTypes.GET_CRITERIA_WITH_FILTERS]: getCriteriaWithFilters,
  [ActionTypes.GET_CRITERIA_WITH_FILTERS_SUCCESS]: getCriteriaWithFiltersSuccess,
  [ActionTypes.GET_CRITERIA_WITH_FILTERS_FAILED]: getCriteriaWithFiltersFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/criteria.js